import { render } from "./RecordingsTable.vue?vue&type=template&id=3da7d8c2&scoped=true"
import script from "./RecordingsTable.vue?vue&type=script&lang=js"
export * from "./RecordingsTable.vue?vue&type=script&lang=js"

import "./RecordingsTable.vue?vue&type=style&index=0&id=3da7d8c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da7d8c2"]])

export default __exports__